<template>
    <div>

        <config-main-title>
            Suprimentos: Tipos de Movimentações
        </config-main-title>

        <div class="form-row mb-0">
            <div class="col col-12" :class="crm ? '' : 'col-md-6'">
                <az-input icon="fas fa-search" v-model="search">
                    <template v-slot:buttonposb>
                        <importacao v-if="false" service="apoiados" @refresh="load()" />
                    </template>
                </az-input>
            </div>
            <div class="col col-12 col-md-3 d-flex flex-column" v-if="!crm">
                <div class="btn-group mb-1" role="group" aria-label="Basic example">
                    <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                    @click="viewMode = 'A'; load();">
                        Ativos
                    </button>
                    <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                    @click="viewMode = 'T'; load();">
                        Todos
                    </button>
                </div>
            </div>
            <div class="col col-12 col-md-3 d-flex flex-column" v-if="!crm">
                <button type="button" class="btn btn-outline-success" @click="incluir ()">
                    Incluir
                </button>
            </div>
        </div>

        <div class="progress mt-1 mb-2">
            <div class="indeterminate" v-if="$store.state.loading && lista && lista.length"></div>
            <div class="determinate" v-else></div>
        </div>

        <div v-if="( !lista || !lista.length )">
            <az-empty-state 
                :msg="'Nenhuma tipo de movimentação identificado.'" 
                icon="fa-solid fa-arrow-down-up-across-line" />
		</div>

        <div v-if="!em_edicao && lista && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between" v-for="(dado, id) in lista" :key="id">
                    <span>
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3" v-if="dado.id_estoque_tipo_movimentacao >= 100">
                            {{ dado.search }}
                        </a>

                        <span class="h5 card-link mb-0 mr-3" v-else>
                            {{ dado.search }}
                        </span>                        
                        
                        <span class="badge badge-secondary ml-2">#{{ dado.id_estoque_tipo_movimentacao }}</span>
                    </span>
                    <span>
                        <div class="custom-control custom-switch" v-if="viewMode == 'T' && dado.id_estoque_tipo_movimentacao >= 100">
                            <input type="checkbox" class="custom-control-input" 
                                :id="'ativo-' + id" 
                                v-model="dado.fl_ativo" 
                                @change="toggle(dado)">
                            <label class="custom-control-label" :for="'ativo-' + id"></label>
                        </div>
                    </span>
                </li>
            </div>

        </div>

        <!-- Formulário de edição -->
        <div class="modal fade" id="edicaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-xl" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{ item && item.id_estoque_tipo_movimentacao ? '' : 'Novo' }}
                            Tipo de Movimentação
                            {{ item && item.id_estoque_tipo_movimentacao ? '#' + item.id_estoque_tipo_movimentacao : '' }}
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">
                        <div class="form-row mb-3">
                            <div class="col col-12">
                                <az-input
                                    sizing="sm"
                                    label="Descrição"
                                    :validate="validate"
                                    required
                                    v-model="item.st_estoque_tipo_movimentacao" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12 col-md-4">
                                <az-input   
                                    type="checkbox-group"
                                    label="Entrada"
                                    :edicao="!item.id_estoque_tipo_movimentacao"
                                    v-model="item.fl_entrada" />
                            </div>

                            <div class="col col-12 col-md-4">
                                <az-input   
                                    type="checkbox-group"
                                    label="Informar Valor"
                                    v-model="item.fl_info_valor" />
                            </div>

                            <div class="col col-12 col-md-4">
                                <az-input   
                                    type="checkbox-group"
                                    label="Informar Fornecedor"
                                    v-model="item.fl_info_fornecedor" />
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <az-audit-log-button model="estoqueTipoMovimentacao" :id="item.id_estoque_tipo_movimentacao" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">{{ item.id_estoque_tipo_movimentacao ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <br><br><br><br><br>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import Importacao from '../shared/Importacao.vue';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            validate: false,
            search: "", 
            viewMode: "A",
            title: "", 
            short_title: "", 
            service: "",
            pesquisar_debounce: null, 
            options_classes: [],
            edicao: null, 
            lista_status: [], 
            acao_anexar: false,
            novo_login: "", 
        }
    },

    props: ['cadastro', 'crm'],

    components: { 
        ConfigMainTitle,
        AzInput,
        AzEmptyState,
        AzSubmit,
        AzAuditLogButton,
        Importacao,
    },

    computed: { 
        lista: function () { 
            return this.dados ? this.dados : [];
        },
    },

    methods: { 
        filtrar(texto) { 
            if ( this.search == '"' + texto + '"' ) { 
                this.search = "";
            } else { 
                this.search = '"' + texto + '"';
            }
        },

        incluir () { 
            this.validate = false;

            let item = {
                id_estoque_tipo_movimentacao: null, 
                st_estoque_tipo_movimentacao: "",
                fl_ativo: true, 
                fl_entrada: true,  
                fl_solicitavel: false, 
                fl_nota_fiscal: false, 
                fl_info_valor: false, 
                fl_info_fornecedor: false, 
            };

            this.editar (item);
        },

        load () { 
            this.$util.load(this, { 
                service:'estoque_tipo_movimentacaos',
                func: 'index',
                parms: { 
                    cadastro: true, 
                },
                loadTo: res => { 
                    this.dados = res;
                }
            });
        },

        editar (item) { 
            this.validate = false;

            if ( item.id_apoiado ) { 

                this.$util.load(this, { 
                    service: 'estoque_tipo_movimentacaos', 
                    func: 'show',
                    parms: { 
                        id: item.id_estoque_tipo_movimentacao,
                        cadastro: true, 
                    },
                    loadTo: res => { 
                        this.item = res;
                        $('#edicaoModal').modal('show');
                    }
                });

            } else { 

                this.item = _.cloneDeep (item);

                $('#edicaoModal').modal('show');

            }
            
        },

        atualizar () { 

            this.$util.atualizar(this, { 
                service: 'estoque_tipo_movimentacaos',
                dados: { 
                    ...this.item,
                    cadastro: true, 
                },
                reload: true, 
                modal: 'edicaoModal',
            });
        },

        fechar () { 
            this.em_edicao = false;

            this.em_edicao = false;
            this.$store.commit('setBreadcrumb', this.breadcrumb);
        },
        toggle (item) { 

            this.$util.toggle(this, { 
                service: 'estoque_tipo_movimentacaos',
                dados: item,
            });

        },
    },

    mounted () { 
        this.load ();

        this.breadcrumb = [
                { name: "Configurações", path: "/cadastros"},
                { name: "Suprimentos: Tipo de Movimentação", method: this.fechar },
            ];
        
        this.$store.commit('setBreadcrumb', this.breadcrumb);

    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>
